import { useEffect } from 'react';
import { create } from 'zustand';
import { AdvanceQuestionWrapper } from 'views/templates/accountOpen/advanceQuestion';
import { CompleteSendMail } from 'views/templates/accountOpen/completeSendMail';

export enum CorporateAccountOpenPages {
  advanceQuestion,
  corporateInfo,
  completeSendMail,
}

export const useCorporateAccountOpen = () => {
  const { accountOpenPageType, reset } = useCorporateAccountOpenPageTypeStore();

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  const SwitchPage = (page: CorporateAccountOpenPages) => {
    switch (page) {
      // 事前質問
      case CorporateAccountOpenPages.advanceQuestion:
        return <AdvanceQuestionWrapper />;

      // メール送信完了
      case CorporateAccountOpenPages.completeSendMail:
        return <CompleteSendMail/>
    }
  };

  return {
    accountOpenPageType,
    SwitchPage,
  };
};

//画面遷移管理
type AccountOpenPageTypeStore = {
  accountOpenPageType: CorporateAccountOpenPages;
  previousPage: CorporateAccountOpenPages;
  setAccountOpenPageType: (navType: CorporateAccountOpenPages) => void;
  setPreviousPage: (navType: CorporateAccountOpenPages) => void;
  reset: () => void;
};

export const useCorporateAccountOpenPageTypeStore = create<AccountOpenPageTypeStore>((set) => ({
  accountOpenPageType: CorporateAccountOpenPages.advanceQuestion,
  previousPage : CorporateAccountOpenPages.advanceQuestion,
  setAccountOpenPageType: (navType: CorporateAccountOpenPages) => set((state) => ({ accountOpenPageType: navType })),
  setPreviousPage : (navType : CorporateAccountOpenPages) => set((state) => ({previousPage: navType})),
  reset: () => set({ accountOpenPageType: CorporateAccountOpenPages.advanceQuestion }),
}));
